import GeneralData from "../../establishments/pages/Tabs/GeneralData";
import UserList from "@/features/establishments/pages/Tabs/Users";
import BillList from "@/features/establishments/pages/Tabs/Bills";
import Totals from "@/features/establishments/pages/Tabs/Totals";
import Events from "@/features/establishments/pages/Tabs/Events";
import Products from "@/features/establishments/pages/Tabs/Products";
import FailedConsumptionsList from "@/features/establishments/pages/Tabs/FailedConsumptions/List";
import EstablishmentPoliticsShow from '../pages/Tabs/Politics/Show';
import TefConfigurationList from "../pages/Tabs/TefConfiguration/List";

export const defaultTabs = [
  {
    label: "Dados Gerais",
    value: "",
    body: <GeneralData />,
  },
  {
    label: "Produtos",
    value: "products",
    body: <Products />,
  },
  {
    label: "Usuários",
    value: "users",
    body: <UserList />,
  },
  {
    label: "Transações",
    value: "events",
    body: <Events />,
  },
  {
    label: "Transações Falhas",
    value: "failed-transactions",
    body: <FailedConsumptionsList />,
  },
  {
    label: "Totalizadores",
    value: "totals",
    body: <Totals />,
  },
  {
    label: "Faturas",
    value: "bills",
    body: <BillList />,
  },
  {
    label: 'Políticas',
    value: 'politics',
    body: <EstablishmentPoliticsShow />,
  },
  {
    label: 'Configurações TEF',
    value: 'tef-configurations',
    body: <TefConfigurationList />,
  },
];
